module.exports = {
  BatchImportOrders: '批量导入订单',
  BatchExportOrders: '批量导出订单',
  BatchExportBills: '批量导出账单',
  BusinessDate: '业务日期',
  OperationDate: '操作日期',
  BillCreationDate: '账单创建日期',
  BillInvoicingDate: '账单开票日期',
  BillReceivingDate: '账单收票日期',
  BillVoucherGenerationDate: '账单生成凭证日期',
  BillNo: '账单号',
  BusinessStatus: '业务状态',
  BusinessType: '业务类型',
  OperatingBranch: '操作分公司',
  ExportSettings: '导出设置',
  AccountsReceivableBills: '应收账单',
  AccountsPayableBills: '应付账单',
  ExportConditions: '导出条件',
  ReminderExportedAtOnce1000: '提醒：单次导出行数不能超过1000行',
  ConfirmExport: '确认导出',
  ExportSuccessful: '导出成功',
  BusinessCreationDate: '业务创建日期',
  Operation: '操作',
  BusinessNumber: '业务编号',
  DirectOrder: '是否直单',
  MasterBillNumber: '主单号',
  MasterBillSerialNumber: '主单流水号',
  OceanFreight: '海运',
  OceanExport: '海运出口',
  OceanImportdirectOrder: '海运进口(直单)',
  AirFreight: '空运',
  AirExport: '空运出口',
  AirImportdirectOrder: '空运进口(直单)',
  All: '全部',
  Yes: '是',
  No: '否',
  DownloadExportResults: '下载导出结果',
  EnterAirImport: '进入空运进口',
  EnterAirExport: '进入空运出口',
  EnterOceanImport: '进入海运进口',
  EnterOceanExport: '进入海运出口',
  DownloadCompleted: '下载完成',
  Return: '返回',
  File: '文件',
  ImportSettings: '导入设置',
  OceanImport: '海运进口',
  AirCargoImport: '空运进口',
  ImportFile: '导入文件',
  SelectFile: '选择文件',
  DownloadTemplate: '下载模板',
  ReminderCannotExceed100Lines: '提醒：单次导入行数不能超过100行',
  ConfirmImport: '确认导入',
  AirCargoImportTemplate: '空运进口导入模板',
  UploadedInXLSOrFormat: '上传文件只能是 XLS 或 XLSX 格式!',
  DownloadImportResult: '下载导入结果',
  DownloadComplete: '下载完成',
  EnterAirCargoImport: '进入空运进口',
  EnterSeaCargoImport: '进入海运进口',
  TotalRecordsMeetTheConditions: '满足导出条件的共有{0}条',
  N0TheConditionsAndExported: '有{0}条不符合条件不导出',
  Success0entriesFailure0entries: '成功{0}条，失败{1}条。'
}
